import { render, staticRenderFns } from "./SettingArrow.vue?vue&type=template&id=3b67cd56"
import script from "./SettingArrow.vue?vue&type=script&lang=js"
export * from "./SettingArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports